import ReportData from "../Utils/ReportData";

export default function ReportContent({ companyName, timestamp, textReportHeader }) {
    return (
      <>
        <ReportData reportHeader={textReportHeader} />
      </>
    );
  }